import { useQuery } from '@tanstack/react-query';
import { businessQueries } from '../api/business-queries';
import type { BusinessListFilter } from './list-params';

interface ListQueryOptions {
  enabled?: boolean;
}

export function useRestaurantCategories(
  filter: BusinessListFilter,
  { enabled = true }: ListQueryOptions = {},
) {
  return useQuery({ ...businessQueries.categoryList(filter), enabled });
}

export function useAllRestaurantCategories({ enabled = true }: ListQueryOptions = {}) {
  return useQuery({ ...businessQueries.categoryAll(), enabled });
}

export function useRestaurantBanners(
  filter: BusinessListFilter,
  { enabled = true }: ListQueryOptions = {},
) {
  return useQuery({ ...businessQueries.restaurantBannerList(filter), enabled });
}

export function useAllRestaurantBanners({ enabled = true }: ListQueryOptions = {}) {
  return useQuery({ ...businessQueries.restaurantBannerAll(), enabled });
}

export function useProductBanners(
  filter: BusinessListFilter,
  { enabled = true }: ListQueryOptions = {},
) {
  return useQuery({ ...businessQueries.productBannerList(filter), enabled });
}

export function useAllProductBanners({ enabled = true }: ListQueryOptions = {}) {
  return useQuery({ ...businessQueries.productBannerAll(), enabled });
}
